<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<modificar-plantilla #modificarplantillahtml (ConfirmoUsuario)="ConfirmoPlantillaHtml($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></modificar-plantilla>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">{{tituloForma}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="position-relative">
        <a type="button" (click)="NuevoCanal()" *ngIf="idTabSeleccionado === 1 && !editarRegistroCanal" class="accesoAdd">
            <mat-icon>add</mat-icon>
        </a>
        <a type="button" (click)="NuevoNotificacion()" *ngIf="idTabSeleccionado === 2 && !editarRegistroNotificacion" class="accesoAdd">
            <mat-icon>add</mat-icon>
        </a>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="idTabSeleccionado === 1 && editarRegistroCanal">
            <a type="button" class="icnTable" (click)="GuardarCanal()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarCanal()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="idTabSeleccionado === 2 && editarRegistroNotificacion">
            <a type="button" class="icnTable" (click)="GuardarNotificacion()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarNotificacion()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="idTabSeleccionado === 3 && editarRegistroParametros">
            <a type="button" class="icnTable" (click)="GuardarParametros()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarParametros()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
    </div>

    <mat-tab-group class="tabcontroldatos" mat-align-tabs="start" #tabGroup (selectedTabChange)="tabSeleccionado($event)">
        <mat-tab>
            <ng-template mat-tab-label>
                <span>Datos</span>
            </ng-template>
            <div [formGroup]="form" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off">
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Nombre (*)</mat-label>
                        <input matInput formControlName="nombre" autocomplete="off">
                        <mat-error *ngIf="form.get('nombre').hasError('required')">El Nombre es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('nombre').hasError('maxlength')">la longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Nombre base datos (*)</mat-label>
                        <input matInput formControlName="nombreBaseDatos" autocomplete="off">
                        <mat-error *ngIf="form.get('nombreBaseDatos').hasError('required')">El Nombre base de datos es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('nombreBaseDatos').hasError('maxlength')">la longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12" *ngIf="form.get('id').value > 0">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Estado (*)</mat-label>
                        <mat-select formControlName="activo">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaEstado">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Identificación</mat-label>
                        <input matInput formControlName="nroIdentificacion" autocomplete="off">
                        <mat-error *ngIf="form.get('nroIdentificacion').hasError('required')">La Identificación es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('nroIdentificacion').hasError('maxlength')">la longitud máxima es 20</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Domicilio</mat-label>
                        <input matInput formControlName="domicilio" autocomplete="off">
                        <mat-error *ngIf="form.get('domicilio').hasError('required')">El Domicilio es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('domicilio').hasError('maxlength')">la longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Sector</mat-label>
                        <mat-select formControlName="idSector" (ngModelChange)="CambioSector()">
                            <mat-option [value]="item.id" *ngFor="let item of this.listaSector">{{item.sector}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Provincia</mat-label>
                        <mat-select formControlName="provincia">
                            <mat-option [value]="item.codigo" *ngFor="let item of this.listaProvincias">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Ciudad</mat-label>
                        <mat-select formControlName="ciudad">
                            <mat-option [value]="item.codigo" *ngFor="let item of this.listaCiudadesEdicion">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Maneja cartera</mat-label>
                        <mat-select formControlName="manejaCartera">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Registrar</mat-label>
                        <mat-select formControlName="registrar">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Calculo precio edad</mat-label>
                        <mat-select formControlName="calculoPrecioEdad">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Notificar registro/cambio estado</mat-label>
                        <mat-select formControlName="notificarCambios">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Recaudo web</mat-label>
                        <mat-select formControlName="recaudoWeb">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Filtrar productos canal</mat-label>
                        <mat-select formControlName="filtrarProductoCanal">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Carga prospectos</mat-label>
                        <mat-select formControlName="cargarProspectos" (ngModelChange)="Cargar_FormatoDefecto()">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12" *ngIf="this.form.get('cargarProspectos')?.value">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Filtro archivo prospecto</mat-label>
                        <mat-select formControlName="filtroFormatoProspecto" (ngModelChange)="Cargar_FormatoDefecto()">
                            <mat-option [value]="item.codigo" *ngFor="let item of this.listaFiltroArchivos">{{item.descripcion}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('filtroFormatoProspecto').hasError('required')">El Filtro archivo prospecto es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('filtroFormatoProspecto').hasError('maxlength')">la longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12" *ngIf="MostrarFormatoProspecto()">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Formato prospecto</mat-label>
                        <input matInput formControlName="nombreFormatoProspecto" autocomplete="off" [readonly]="true">
                        <mat-error *ngIf="form.get('nombreFormatoProspecto').hasError('required')">El Formato prospecto es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('nombreFormatoProspecto').hasError('maxlength')">la longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Maneja programas</mat-label>
                        <mat-select formControlName="manejaProgramas">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Maneja expedientes</mat-label>
                        <mat-select formControlName="expedientes">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Cambiar estado afiliacion recurrente</mat-label>
                        <mat-select formControlName="cambioEstadoAfiliacion">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Migrar clientes aliados</mat-label>
                        <mat-select formControlName="migracionClientesAliados">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-2 col-12" *ngIf="MostrarMigracionClientesAliados()">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Nombre clientes aliados</mat-label>
                        <input matInput formControlName="nombreClientesAliados" autocomplete="off">
                    </mat-form-field>
                </div>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <span>Canales</span>
            </ng-template>
            <div class="d-flex flex-column">
                <div [formGroup]="formCanales" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroCanal">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Canal (*)</mat-label>
                            <input matInput formControlName="nombre" autocomplete="off">
                            <mat-error *ngIf="formCanales.get('nombre').hasError('required')">El Canal es un campo requerido</mat-error>
                            <mat-error *ngIf="formCanales.get('nombre').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="formCanales.get('id').value > 0">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Estado (*)</mat-label>
                            <mat-select formControlName="activo">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaEstado">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Domicilio</mat-label>
                            <input matInput formControlName="domicilio" autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Provincias</mat-label>
                            <mat-select formControlName="provincia">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listaProvincias">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formCanales.get('provincia').hasError('required')">La Provincia es un campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Ciudad</mat-label>
                            <mat-select formControlName="ciudad">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listaCiudadesEdicionCanal">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formCanales.get('ciudad').hasError('required')">La Ciudad es un campo requerido</mat-error>
                        </mat-form-field>
                    </div>

                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceCanales" matSort class="table table-striped table-hover">

                            <!-- id Column -->
                            <ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                            </ng-container>
                            <!-- nombre Column -->
                            <ng-container matColumnDef="nombre">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
                                <td mat-cell *matCellDef="let row"> {{row.nombre}} </td>
                            </ng-container>
                            <!-- activo Column -->
                            <ng-container matColumnDef="activo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Activo </th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-checkbox [(ngModel)]="row.activo" [disabled]="true">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                            <!-- acciones Column -->
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarCanal(row)" *ngIf="!editarRegistroCanal">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarCanal(row)" *ngIf="!editarRegistroCanal">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoCanales"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoCanales;"></tr>

                            <!-- Row shown when there is no matching data. -->
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
        <mat-tab *ngIf="this.mostrarEdicionNotificaciones">
            <ng-template mat-tab-label>
                <span>Notificaciones</span>
            </ng-template>
            <div class="d-flex flex-column">
                <div [formGroup]="formNotificaciones" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroNotificacion">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Tipo proceso (*)</mat-label>
                            <mat-select formControlName="tipoProceso">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listaTipoProceso">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formNotificaciones.get('tipoProceso').hasError('required')">El Tipo proceso es un campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Enviar SMS</mat-label>
                            <mat-select formControlName="enviarSMS">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Enviar Email</mat-label>
                            <mat-select formControlName="enviarEmail">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Activo</mat-label>
                            <mat-select formControlName="activo">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div [formGroup]="formNotificaciones" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroNotificacion">
                    <div class="col-md-12 col-lg-3 col-12" *ngIf="formNotificaciones.get('enviarEmail').value">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Email-De</mat-label>
                            <input matInput formControlName="emailFrom" autocomplete="off">
                            <mat-error *ngIf="formNotificaciones.get('emailFrom').hasError('required')">El Email-De es un campo requerido</mat-error>
                            <mat-error *ngIf="formNotificaciones.get('emailFrom').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-3 col-12" *ngIf="formNotificaciones.get('enviarEmail').value">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Email-Copia a</mat-label>
                            <input matInput formControlName="emailReplyTo" autocomplete="off">
                            <mat-error *ngIf="formNotificaciones.get('emailReplyTo').hasError('required')">El Email-Copia a es un campo requerido</mat-error>
                            <mat-error *ngIf="formNotificaciones.get('emailReplyTo').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-3 col-12" *ngIf="formNotificaciones.get('enviarEmail').value">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Email-Asunto</mat-label>
                            <input matInput formControlName="emailSubject" autocomplete="off">
                            <mat-error *ngIf="formNotificaciones.get('emailSubject').hasError('required')">El Email-Asunto es un campo requerido</mat-error>
                            <mat-error *ngIf="formNotificaciones.get('emailSubject').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-3 col-12" *ngIf="formNotificaciones.get('enviarEmail').value">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Email-Mensaje</mat-label>
                            <input matInput formControlName="emailMensajeMostrar" autocomplete="off">
                            <button matSuffix mat-icon-button (click)="EditarContenidoHTML()">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <mat-error *ngIf="formNotificaciones.get('emailMensajeMostrar').hasError('required')">El Email-Mensaje es un campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-12 col-12" *ngIf="formNotificaciones.get('enviarSMS').value">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Mensaje SMS</mat-label>
                            <input matInput formControlName="smsTexto" autocomplete="off">
                            <mat-error *ngIf="formNotificaciones.get('smsTexto').hasError('required')">El Mensaje SMS es un campo requerido</mat-error>
                            <mat-error *ngIf="formNotificaciones.get('smsTexto').hasError('maxlength')">La longitud máxima es 260</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceNotificaciones" matSort class="table table-striped table-hover">

                            <!-- id Column -->
                            <ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                            </ng-container>
                            <!-- descripcionTipoProceso Column -->
                            <ng-container matColumnDef="descripcionTipoProceso">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo proceso </th>
                                <td mat-cell *matCellDef="let row"> {{row.descripcionTipoProceso}} </td>
                            </ng-container>
                            <!-- enviarSMS Column -->
                            <ng-container matColumnDef="enviarSMS">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Enviar SMS </th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-checkbox [(ngModel)]="row.enviarSMS" [disabled]="true">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                            <!-- enviarEmail Column -->
                            <ng-container matColumnDef="enviarEmail">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Enviar Email </th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-checkbox [(ngModel)]="row.enviarEmail" [disabled]="true">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                            <!-- activo Column -->
                            <ng-container matColumnDef="activo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Activo </th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-checkbox [(ngModel)]="row.activo" [disabled]="true">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                            <!-- acciones Column -->
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarNotificacion(row)" *ngIf="!editarRegistroNotificacion">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarNotificacion(row)" *ngIf="!editarRegistroNotificacion">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoNotificaciones"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoNotificaciones;"></tr>

                            <!-- Row shown when there is no matching data. -->
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
        <mat-tab *ngIf="this.EsEdicionRegistro()">
            <ng-template mat-tab-label>
                <span>Parámetros</span>
            </ng-template>
            <div class="d-flex flex-column">
                <div [formGroup]="formParametros" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroParametros">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Nombre (*)</mat-label>
                            <input matInput formControlName="parametro" autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Valor parámetro (*)</mat-label>
                            <input matInput formControlName="valorParametro" autocomplete="off">
                        </mat-form-field>
                    </div>
                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceParametros" matSort class="table table-striped table-hover">

                            <ng-container matColumnDef="parametro">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre</th>
                                <td mat-cell *matCellDef="let row"> {{row.parametro}} </td>
                            </ng-container>
                            <ng-container matColumnDef="valorParametro">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Valor </th>
                                <td mat-cell *matCellDef="let row"> {{row.valorParametro}} </td>
                            </ng-container>
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarParametros(row)" *ngIf="!editarRegistroParametros">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoParametros"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoParametros;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div class="d-flex flex-row-reverse pr-0" *ngIf="idTabSeleccionado === 0 || (idTabSeleccionado === 1 && !editarRegistroCanal) || (idTabSeleccionado === 2 && !editarRegistroNotificacion) || (idTabSeleccionado === 3 && !editarRegistroParametros)">
        <div *ngIf="this.tamanoAppService.mostrarModoEscritorio">
            <button mat-button class="botonguardardatos" (click)="Guardar()" [disabled]="mostrarCargando">
                <div class="d-flex flex-row-reverse">
                    <mat-icon class="botonguardardatosicono">check_circle_outline</mat-icon>
                    <span class="botonguardardatostexto">{{tituloBoton}}</span>
                </div>
            </button>
        </div>
    </div>
</div>